<template>
  <div class="sentence-completion">

    <Instructions
        v-if="showInstructions"
        :sentences
        :showInstructions
        :workStarted />

    <form v-if="!showInstructions && workStarted && !sentencesComplete" class="sentence-inputs">
      <div class="form-header">
        <p>Sentence {{ currentlyCompleting }} of {{ sentences.length }}</p>
        <button class="button hollow primary instructions"
                @click.prevent="showInstructions = true">Instructions
        </button>
      </div>
      <div class="progress">
        <span v-for="(sentence, index) in sentences" @click="currentlyCompleting = index + 1"
              :class="{complete: index < currentlyCompleting}">
          {{ ((index + 1) % 5 === 0) ? index + 1 : "" }} {{ ((index + 1) === 1) ? index + 1 : "" }}
        </span>
      </div>
      <textarea v-for="(sentence, index) in sentences" v-show="index === (currentlyCompleting - 1)"
                @change="updateSentence($event, index)">{{ sentence.value }}</textarea>
      <nav>
        <button v-if="(currentlyCompleting > 1) && !sentencesComplete" class="button filled primary prev"
                @click.prevent="previousSentence">Prev
        </button>
        <button v-if="(currentlyCompleting < sentences.length) && !sentencesComplete" class="button filled primary next"
                @click.prevent="nextSentence">Next
        </button>
        <button v-if="(currentlyCompleting === sentences.length) && !sentencesComplete"
                class="button filled accent-1 finish"
                @click.prevent="sentencesComplete = true">Finish
        </button>
      </nav>
    </form>

    <div v-if="sentencesComplete" class="reflection">
      <div class="reflection-header">
        <h3 class="h4 strong">Congratulations</h3>
        <p>You have completed the first portion of this exercise, but now the real work begins... Its time for
           reflection. Below you will see your completed sentences along with some reflection prompts. Grab yourself a
           journal, notepad, or use the provided textarea below to capture your thoughts.</p>
        <textarea v-model="selfReflection"
                  placeholder="Your reflections will be included in your PDF download"></textarea>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2">

        <div class="completed-sentences">
          <h4>Completed Sentences</h4>
          <ul class="sentences">
            <li v-for="(sentence, index) in sentences">
              <p v-show="currentlyEditing !== index" class="entry">
                {{ sentence.value }}
                <span v-show="currentlyEditing !== index" class="edit" @click="editSentence(index)">(edit)</span>
              </p>

              <textarea v-show="currentlyEditing === index" @change="updateSentence($event, index)">{{ sentence.value.trim() }}</textarea>
              <span v-show="currentlyEditing === index" class="save" @click="saveSentence(index)">(save)</span>
            </li>

          </ul>
        </div>
        <div class="prompts">
          <h4>Reflection Prompts</h4>
          <ul>
            <li v-for="reflectionPrompt in reflectionPrompts">{{ reflectionPrompt }}</li>
          </ul>

          <h5>The Big Question: Why?</h5>
          <p>For each one of your completed sentences, frame a "Why" question around it. For example: starting with the
             first prompt, "I like...", you would ask yourself, "Why do I like... ?" Is there a domestication behind your
             response? As in, do you believe this because you were taught to believe this (either directly or through
             adoption of cultural norms)? Or maybe your response is bound to an emotion. Maybe it triggers a joyous or
             traumatic event from your life!</p>
          <p>Don't rush your reflection. Take your time. Download a PDF with your completed sentences and the above
             reflection prompts to continue offline</p>

          <pdfGenerator
              v-if="sentencesComplete"
              :sentences
              :reflectionPrompts
              :selfReflection />

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import pdfGenerator from "./pdfGenerator.vue";
import Instructions from "./Instructions.vue";

export default {
  components: {pdfGenerator, Instructions},
  props:      {},

  data() {
    return {
      editingSentence:     false,
      currentlyEditing:    null,
      selfReflection:      "",
      pdfContent:          "",
      currentlyCompleting: 1,
      workStarted:         0,
      showInstructions:    true,
      sentencesComplete:   false,
      sentences:           [
        {value: "I like... "},
        {value: "The happiest time... "},
        {value: "I want to know... "},
        {value: "Back home... "},
        {value: "I regret... "},
        {value: "At bedtime... "},
        {value: "Men... "},
        {value: "The best... "},
        {value: "What annoys me... "},
        {value: "People... "},
        {value: "A mother... "},
        {value: "I feel... "},
        {value: "My greatest fear... "},
        {value: "In school... "},
        {value: "I can't... "},
        {value: "Sports... "},
        {value: "When I was a child... "},
        {value: "My nerves... "},
        {value: "Other people... "},
        {value: "I suffer... "},
        {value: "I failed... "},
        {value: "Reading... "},
        {value: "My mind... "},
        {value: "The future... "},
        {value: "I need... "},
        {value: "Marriage... "},
        {value: "I am best when... "},
        {value: "Sometimes... "},
        {value: "What pains me... "},
        {value: "I hate... "},
        {value: "This place... "},
        {value: "I am very... "},
        {value: "The only trouble... "},
        {value: "I wish... "},
        {value: "My father... "},
        {value: "I secretly... "},
        {value: "I... "},
        {value: "Dancing... "},
        {value: "My greatest worry is... "},
        {value: "Most women... "},
      ],
      reflectionPrompts:   [
        "Is there anything that stands out? Surprises you? Is unexpected?",
        "What do you think your responses say about your values?",
        "Are there repeated themes or patterns within your responses?",
        "Is the general tone positive or negative? Hopeful or hopeless? Solution oriented or confrontational?",
        "Was there any sense of pride or shame that any of your responses evoked?",
      ]
    };
  },
  mounted() {
    console.log(this.sentences);

  },
  computed: {},
  methods:  {
    updateSentence(event, index) {
      console.log(event);
      this.sentences[index].value = event.target.value;
      // console.log(this.sentences)
    },
    previousSentence() {
      this.currentlyCompleting = this.currentlyCompleting - 1;
      // console.log(this.currentlyCompleting)
    },
    nextSentence() {
      this.currentlyCompleting = this.currentlyCompleting + 1;
      // console.log(this.currentlyCompleting)
    },
    editSentence(index) {
      this.editingSentence = true;
      this.currentlyEditing = index;
    },
    saveSentence() {
      this.editingSentence = false;
      this.currentlyEditing = null;
    },
  }
}
</script>
